import api, { getData } from '@/axiosConfig'
import { ValidateEmail, status, storeModules } from '../../helpers'
import i18n from '../../internatinalization/i18n'
const gemnoteAPI = api()

import {
  LOAD_MEMBERS_LIST,
  SET_MEMBERS,
  START_SEND_INVITATIONS,
  END_SEND_INVITATIONS,
  SET_INVITATION_DETAILS,
  LOAD_INVITATIONS,
  SET_INVITATIONS,
  ADD_INVITATION,
  RESET_TEAM_STATE,
  ADD_USER_TO_REMOVE,
  CLEAN_USER_TO_REMOVE,
  SET_CURRENT_TEAM,
  UPDATE_MEMBER,
  REMOVE_USER_FROM_TEAM,
  REMOVE_INVITATION,
  SET_INVENTORY_CHART,
  SET_MEMBERS_PAGINATION_COUNT,
  SET_INVITATION_PAGINATION_COUNT
} from '@/state/mutationTypes'

export default {
  // eslint-disable-next-line no-unused-vars
  async getTeam({ commit, dispatch }, betaRedirect = () => {}) {
    try {
      const response = await gemnoteAPI.get('team')
      const data = getData(response)
      // betaRedirect(data)
      let teamInventoryData = {
        datasets: [
          {
            data: [
              data.attributes.remainingSubscriptionInventory,
              data.attributes.inventoryCount
            ],
            backgroundColor: ['#232220', '#DFDAD2'],
            borderColor: ['transparent', 'transparent'],
            hoverBorderColor: ['#DFDAD2', '#DFDAD2'],
            hoverBorderWidth: 1
          }
        ],
        labels: ['Remaining', 'Total']
      }
      commit(SET_INVENTORY_CHART, teamInventoryData)

      // Set current team info
      commit(SET_CURRENT_TEAM, {
        id: data.id,
        ...data.attributes,
        preferencesBlob: data.attributes.preferencesBlob
          .nonDeliveryOptionForInternationalShipment
          ? data.attributes.preferencesBlob
              .nonDeliveryOptionForInternationalShipment
          : '',
        stockThresholdNotificationsEnabled: data.attributes.preferencesBlob
          .stockThresholdNotificationsEnabled
          ? data.attributes.preferencesBlob.stockThresholdNotificationsEnabled
          : false,
        teamLogo: data.attributes.teamLogo ? data.attributes.teamLogo : {},
        teamCustomBackground: data.attributes.teamCustomBackground
          ? data.attributes.teamCustomBackground
          : {},
        teamModuleNames:
          data.attributes.teamModuleNames !== null
            ? data.attributes.teamModuleNames
            : [storeModules.project]
      })
    } catch (error) {
      console.log(error)
      let errors = []
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [errors[0].message]
            },
            { root: true }
          )
        }
      } else if (error.request) {
        errors.push(i18n.t('server.no-response'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      } else {
        errors.push(i18n.t('team.action.get-team-info-error'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      }
    }
  },
  async updateTeamPreferences({ commit, dispatch, state }) {
    try {
      let team = state.team
      const response = await gemnoteAPI.patch('team', {
        team: {
          non_delivery_option_for_international_shipment: team.preferencesBlob
        }
      })
      const data = getData(response)
      commit(SET_CURRENT_TEAM, {
        id: data.id,
        ...data.attributes,
        preferencesBlob: data.attributes.preferencesBlob
          .nonDeliveryOptionForInternationalShipment
          ? data.attributes.preferencesBlob
              .nonDeliveryOptionForInternationalShipment
          : '',
        teamLogo: data.attributes.teamLogo ? data.attributes.teamLogo : {},
        teamCustomBackground: data.attributes.teamCustomBackground
          ? data.attributes.teamCustomBackground
          : {},
        teamModuleNames:
          data.attributes.teamModuleNames !== null
            ? data.attributes.teamModuleNames
            : [storeModules.project]
      })

      if (response.status == 200) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'success',
            messages: [i18n.t('profile.action.update-shipping-success')]
          },
          { root: true }
        )
      }
    } catch (error) {
      console.log(error)
      let errors = []
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [errors[0].message]
            },
            { root: true }
          )
        }
      } else if (error.request) {
        errors.push(i18n.t('server.no-response'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      } else {
        errors.push(i18n.t('profile.action.team-preferences-error'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      }
    }
  },
  async uploadTeamLogoAndBackground(
    { commit, dispatch },
    { storeData, removeImageAction, updateType }
  ) {
    try {
      const response = await gemnoteAPI({
        method: 'PATCH',
        url: 'team',
        data: storeData,
        config: {
          headers: { 'Content-Type': 'multipart/form-data' }
        }
      })

      const data = getData(response)
      commit(SET_CURRENT_TEAM, {
        id: data.id,
        ...data.attributes,
        preferencesBlob: data.attributes.preferencesBlob
          .nonDeliveryOptionForInternationalShipment
          ? data.attributes.preferencesBlob
              .nonDeliveryOptionForInternationalShipment
          : '',
        teamLogo: data.attributes.teamLogo ? data.attributes.teamLogo : {},
        teamCustomBackground: data.attributes.teamCustomBackground
          ? data.attributes.teamCustomBackground
          : {},
        teamModuleNames:
          data.attributes.teamModuleNames !== null
            ? data.attributes.teamModuleNames
            : [storeModules.project]
      })

      if (response.status == 200) {
        if (removeImageAction) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'success',
              messages: [
                updateType === 'background'
                  ? i18n.t('profile.action.remove-background-success')
                  : i18n.t('profile.action.remove-logo-success')
              ]
            },
            { root: true }
          )
        } else {
          dispatch(
            'notification/pushNotification',
            {
              type: 'success',
              messages: [i18n.t('profile.action.update-logo-success')]
            },
            { root: true }
          )
        }
        dispatch(
          'notification/pushNotification',
          {
            type: 'success',
            messages: [i18n.t('profile.action.update-logo-success')]
          },
          { root: true }
        )
      }
    } catch (error) {
      console.log(error)
      let errors = []
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [errors[0].message]
            },
            { root: true }
          )
        }
      } else if (error.request) {
        errors.push(i18n.t('server.no-response'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      } else {
        errors.push(i18n.t('profile.action.team-logo-error'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      }
    }
  },
  async loadMembers({ commit, dispatch }, { page = 1, perPage = 50 }) {
    commit(LOAD_MEMBERS_LIST, status.LOADING)
    try {
      const response = await gemnoteAPI.get(
        `team/members?page[number]=${page}&page[size]=${perPage}`
      )
      let { totalCount } = response.data.meta
      const data = getData(response)
      let resultingMembers = data.map(member => {
        return {
          id: member.id,
          email: member.attributes.email,
          name: member.attributes.name,
          availableBudgetAmount: member.attributes.availableBudgetAmount
            ? parseFloat(member.attributes.availableBudgetAmount).toFixed(2)
            : 0,
          infiniteTeamUserBudget: member.attributes.infiniteTeamUserBudget
            ? member.attributes.infiniteTeamUserBudget
            : false,
          role: member.attributes.roles.length
            ? member.attributes.roles[0] === 'team_owner'
              ? 'Admin'
              : 'User'
            : 'User',
          status: 'Accepted invitation',
          subteam: member.attributes.subteam
            ? {
                id: parseInt(member.attributes.subteam.id),
                name: member.attributes.subteam.name
              }
            : { id: -1, name: 'None' }
        }
      })
      commit(SET_MEMBERS_PAGINATION_COUNT, totalCount)
      commit(SET_MEMBERS, resultingMembers)
      commit(LOAD_MEMBERS_LIST, status.LOADED)
    } catch (error) {
      console.log(error)
      commit(LOAD_MEMBERS_LIST, status.ERROR)
      commit(SET_MEMBERS, [])
      let errors = []
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [errors[0].message]
            },
            { root: true }
          )
        }
      } else if (error.request) {
        errors.push(i18n.t('server.no-response'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      } else {
        errors.push(i18n.t('team.action.get-team-members-error'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      }
    }
  },

  /**
   * sends invite to user, gets invitation token
   * NOTE -- must set tries first
   * POST /api/v2/team/invitations
   *
   * @param {Object} newUser - object to send to server, containing new user email
   * @param {String} newUser.email - email of the prospective user to send to
   */
  async createAndSendInvitation(
    { commit, dispatch, rootState },
    usersToInviteObject
  ) {
    commit(START_SEND_INVITATIONS)
    let errorsList = []
    try {
      let emailObjectsToSend = usersToInviteObject.filter(
        emailObject => emailObject.email !== ''
      )
      if (emailObjectsToSend.length === 0) {
        errorsList.push(i18n.t('validations.set-one-valid-email'))
      } else {
        emailObjectsToSend.map(invitation => {
          if (!ValidateEmail(invitation.email))
            errorsList.push(
              i18n.t('validations.list-of-no-valid-emails', {
                '0': invitation.email
              })
            )
        })
      }

      if (errorsList.length) {
        commit(END_SEND_INVITATIONS)
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errorsList
          },
          { root: true }
        )
        return
      }

      let promises = emailObjectsToSend.map(userInvite => {
        return new Promise(async resolve => {
          try {
            let response = await gemnoteAPI.post('team/invitations', {
              invitation: {
                email: userInvite.email
              }
            })
            let data = getData(response)

            let inviteResult = {
              id: data.id,
              email: `${data.attributes.email} (<i>${data.attributes.state}</i>)`,
              token: data.attributes.token,
              state: data.attributes.state
            }

            return resolve({
              success: true,
              inviteResult,
              message: i18n.t('team.action.invited-email-message', {
                '0': data.attributes.email
              })
            })
          } catch (error) {
            if (error.response) {
              if (
                error.response.status === 500 ||
                error.response.status === 404
              ) {
                return resolve({
                  success: false,
                  message:
                    error.response.status === 500
                      ? i18n.t('server.server-error')
                      : i18n.t('server.not-found')
                })
              } else {
                let { errors } = error.response.data
                return resolve({
                  success: false,
                  message: `${userInvite.email}: ${errors[0].message[0]}`
                })
              }
            } else if (error.request) {
              return resolve({
                success: false,
                message: i18n.t('server.no-response')
              })
            } else {
              return resolve({
                success: false,
                message: i18n.t('team.action.member-invitation-error', {
                  '0': userInvite.email
                })
              })
            }
          }
        })
      })

      Promise.all(promises)
        .then(userInvitationsResult => {
          let successInvites = userInvitationsResult.filter(
            userInvite => userInvite.success
          )

          let failedInvited = userInvitationsResult.filter(
            userInvite => !userInvite.success
          )

          if (successInvites.length && failedInvited.length) {
            commit(
              ADD_INVITATION,
              successInvites.map(success => success.inviteResult)
            )
            dispatch(
              'notification/pushNotification',
              {
                type: 'info',
                messages: userInvitationsResult.map(success => success.message)
              },
              { root: true }
            )
          } else if (successInvites.length && !failedInvited.length) {
            commit(
              ADD_INVITATION,
              successInvites.map(success => success.inviteResult)
            )
            dispatch(
              'notification/pushNotification',
              {
                type: 'success',
                messages: successInvites.map(success => success.message)
              },
              { root: true }
            )
          } else {
            dispatch(
              'notification/pushNotification',
              {
                type: 'error',
                messages: failedInvited.map(failed => failed.message)
              },
              { root: true }
            )
          }

          commit(END_SEND_INVITATIONS)
          if (!rootState.showModal) {
            dispatch('modal/hideModal', null, { root: true })
          }
        })
        .catch(error => {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: error
            },
            { root: true }
          )
          commit(END_SEND_INVITATIONS)
        })
    } catch (error) {
      console.log(error)
      let errors = []
      commit(END_SEND_INVITATIONS)
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: errors
            },
            { root: true }
          )
        }
      } else if (error.request) {
        errors.push(i18n.t('server.no-response'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      } else {
        errors.push(i18n.t('team.action.member-invitation-exception'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      }
    }
  },
  async loadInvitations(
    { commit, dispatch, rootGetters },
    { page = 1, perPage = 50 }
  ) {
    try {
      let isTeamOwner = rootGetters['profile/isTeamOwner']
      if (isTeamOwner) {
        commit(LOAD_INVITATIONS, status.LOADING)
        const response = await gemnoteAPI.get(
          `team/invitations?page[number]=${page}&page[size]=${perPage}`
        )
        // console.log(response)
        let { totalCount } = response.data.meta
        const data = getData(response)
        let resultingInvitations = data
          .filter(
            invitation =>
              invitation.attributes.state !== 'canceled' &&
              invitation.attributes.state !== 'accepted'
          )
          .map(invitation => {
            return {
              id: invitation.id,
              email: `${invitation.attributes.email} (<i>${invitation.attributes.state}</i>)`,
              token: invitation.attributes.token,
              inviteState: invitation.attributes.state,
              state: invitation.attributes.state
            }
          })
        commit(SET_INVITATION_PAGINATION_COUNT, totalCount)
        commit(SET_INVITATIONS, resultingInvitations)
        commit(LOAD_INVITATIONS, status.LOADED)
      } else {
        commit(SET_INVITATIONS, [])
      }
    } catch (error) {
      console.log(error)
      commit(LOAD_INVITATIONS, status.ERROR)
      commit(SET_INVITATIONS, [])
      let errors = []
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [errors[0].message]
            },
            { root: true }
          )
        }
      } else if (error.request) {
        errors.push(i18n.t('server.no-response'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      } else {
        errors.push(i18n.t('team.action.get-team-invitations-error'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      }
    }
  },
  async getInvitationDetails({ commit, dispatch }, token) {
    try {
      commit(LOAD_MEMBERS_LIST, status.LOADING)
      let response = await gemnoteAPI.get(`invitations/${token}`)
      let invitationDetails = getData(response)

      invitationDetails = {
        id: invitationDetails.id,
        email: invitationDetails.attributes.email,
        token: invitationDetails.attributes.token,
        state: invitationDetails.attributes.state,
        userName: '',
        userLastName: '',
        password: null,
        reTypePassword: null
      }
      commit(SET_INVITATION_DETAILS, invitationDetails)
      commit(LOAD_MEMBERS_LIST, status.LOADED)
    } catch (error) {
      commit(LOAD_MEMBERS_LIST, status.LOADED)
      console.log(error)
      let errors = []
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [errors[0].message]
            },
            { root: true }
          )
        }
      } else if (error.request) {
        errors.push(i18n.t('server.no-response'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      } else {
        errors.push(i18n.t('team.action.get-invitation-detail-error'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      }
    }
  },
  async acceptInvitation({ commit, dispatch }, invitationObject) {
    try {
      let errorsList = []

      let {
        token,
        email,
        userName,
        userLastName,
        password,
        reTypePassword
      } = invitationObject

      // let isValidEmail = ValidateEmail(email)
      // if (!isValidEmail)
      // errorsList.push('You have entered an invalid email address!')
      if (!userName) errorsList.push(i18n.t('validations.blank-username'))
      if (!userLastName) errorsList.push(i18n.t('validations.blank-lastname'))

      if (!password) errorsList.push(i18n.t('validations.blank-password'))
      if (!reTypePassword)
        errorsList.push(i18n.t('validations.blank-password-retype'))
      if (password !== reTypePassword)
        errorsList.push(i18n.t('validations.not-matched-passwords'))

      if (errorsList.length) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errorsList
          },
          { root: true }
        )
        return
      }

      let response = await gemnoteAPI.post(`invitations/${token}/accept`, {
        user: {
          password: password,
          first_name: userName,
          last_name: userLastName
        }
      })
      let acceptInvitation = getData(response)
      invitationObject.succeed = true
      invitationObject.state = acceptInvitation.attributes.state
      commit(SET_INVITATION_DETAILS, invitationObject)
      let credentials = {
        email,
        password,
        fromSignUp: false,
        fromInvitation: true
      }
      await dispatch('auth/login', credentials, { root: true })
    } catch (error) {
      console.log(error)
      let errors = []
      if (error.response) {
        let { errors } = error.response.data
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [...errors[0].message]
          },
          { root: true }
        )
      } else if (error.request) {
        errors.push(i18n.t('server.no-response'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      } else {
        errors.push(i18n.t('team.action.accept-invitation-error'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      }
    }
  },
  async resendInvitation({ dispatch }, token) {
    try {
      await gemnoteAPI.post(`team/invitations/${token}/resend`)
      dispatch(
        'notification/pushNotification',
        {
          type: 'success',
          messages: [i18n.t('team.action.resend-invitation-success')]
        },
        { root: true }
      )
    } catch (error) {
      console.log(error)
      let errors = []
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [errors[0].message]
            },
            { root: true }
          )
        }
      } else if (error.request) {
        errors.push(i18n.t('server.no-response'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      } else {
        errors.push(i18n.t('team.action.resend-invitation-error'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      }
    }
  },
  async removeInvitation({ commit, dispatch }, token) {
    try {
      await gemnoteAPI.delete(`team/invitations/${token}`)
      dispatch(
        'notification/pushNotification',
        {
          type: 'success',
          messages: [i18n.t('team.action.remove-invitation-success')]
        },
        { root: true }
      )
      commit(REMOVE_INVITATION, token)
    } catch (error) {
      console.log(error)
      let errors = []
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else if (error.response.status === 422) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: ['Validation failed: Email has already been taken.']
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [errors[0].message]
            },
            { root: true }
          )
        }
      } else if (error.request) {
        errors.push(i18n.t('server.no-response'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      } else {
        errors.push(i18n.t('team.action.remove-invitation-error'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      }
    }
  },
  async addUserListToRemove({ commit }, { id, name }) {
    commit(ADD_USER_TO_REMOVE, { id, name })
  },
  async removeUsersFromTeam({ commit, dispatch, state }) {
    try {
      let usersToRemove = state.usersToRemove
      if (usersToRemove.length) {
        let errors = []
        let promises = usersToRemove.map(user => {
          let { id } = user
          return new Promise(async (resolve, reject) => {
            try {
              await gemnoteAPI.delete(`team/members/${id}`)
              return resolve({
                success: true,
                id
              })
            } catch (error) {
              console.log(error)
              if (error.response) {
                errors.push(
                  i18n.t('team.action.remove-user-team-error', {
                    '0': id
                  })
                )
                errors.push(error.response.data.errors[0].message)
                return reject(errors)
              } else {
                errors.push(i18n.t('team.action.remove-user-exception'))
                return reject(errors)
              }
            }
          })
        })

        Promise.all(promises)
          .then(results => {
            let userIdsToRemove = results.map(result => result.id)
            userIdsToRemove.forEach(id => {
              commit(REMOVE_USER_FROM_TEAM, id)
            })
            commit(CLEAN_USER_TO_REMOVE)
          })
          .catch(errors => {
            dispatch(
              'notification/pushNotification',
              {
                type: 'error',
                messages: errors
              },
              { root: true }
            )
          })
      } else {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('team.action.no-selected-users-to-remove')]
          },
          { root: true }
        )
      }
    } catch (error) {
      console.log(error)
      let errors = []
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: errors
            },
            { root: true }
          )
        }
      } else if (error.request) {
        errors.push(i18n.t('server.no-response'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      } else {
        errors.push(i18n.t('team.action.remove-user-exception'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      }
    }
  },
  async changeUserRole({ commit, dispatch }, userObject) {
    try {
      let { userId, role } = userObject
      let body = {
        user: {
          roles: [role]
        }
      }

      let response = await gemnoteAPI.put(`team/members/${userId}`, body)
      const data = getData(response)
      let memberToUpdate = {
        id: data.id,
        email: data.attributes.email,
        name: data.attributes.name,
        availableBudgetAmount: data.attributes.availableBudgetAmount
          ? parseFloat(data.attributes.availableBudgetAmount).toFixed(2)
          : 0,
        infiniteTeamUserBudget: data.attributes.infiniteTeamUserBudget
          ? data.attributes.infiniteTeamUserBudget
          : false,
        role: data.attributes.roles.length
          ? data.attributes.roles[0] === 'team_owner'
            ? 'Admin'
            : 'User'
          : 'User',
        status: 'Accepted invitation',
        subteam: data.attributes.subteam
          ? {
              id: parseInt(data.attributes.subteam.id),
              name: data.attributes.subteam.name
            }
          : { id: -1, name: 'None' }
      }
      commit(UPDATE_MEMBER, memberToUpdate)

      dispatch(
        'notification/pushNotification',
        {
          type: 'success',
          messages: [i18n.t('team.action.user-role-update-success')]
        },
        { root: true }
      )
    } catch (error) {
      console.log(error)
      let errors = []
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [errors[0].message]
            },
            { root: true }
          )
        }
      } else if (error.request) {
        errors.push(i18n.t('server.no-response'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      } else {
        errors.push(i18n.t('team.action.user-role-update-error'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      }
    }
  },
  async addCreditsToUser(
    { commit, dispatch, rootState },
    { userId, creditsAmount, isInfinite }
  ) {
    try {
      let payload
      if (isInfinite) {
        payload = {
          budget: {
            infinite_budget: true
          }
        }
      } else {
        payload = {
          budget: {
            amount: creditsAmount,
            note: `added ${creditsAmount} credits to user ${userId}`,
            infinite_budget: false
          }
        }
      }

      const response = await gemnoteAPI.post(
        `team/users/${userId}/budget`,
        payload
      )
      const data = getData(response)

      // if current user is the same user for what we are adding credits, dispatch action to get fresh user info.
      if (rootState.profile.user.id === userId) {
        await dispatch(
          'profile/getProfile',
          { reloadProfile: false },
          { root: true }
        )
      }

      let memberToUpdate = {
        id: data.id,
        email: data.attributes.email,
        name: data.attributes.name,
        availableBudgetAmount: data.attributes.availableBudgetAmount
          ? parseFloat(data.attributes.availableBudgetAmount).toFixed(2)
          : 0,
        infiniteTeamUserBudget: data.attributes.infiniteTeamUserBudget
          ? data.attributes.infiniteTeamUserBudget
          : false,
        role: data.attributes.roles.length
          ? data.attributes.roles[0] === 'team_owner'
            ? 'Admin'
            : 'User'
          : 'User',
        status: 'Accepted invitation',
        subteam: data.attributes.subteam
          ? {
              id: parseInt(data.attributes.subteam.id),
              name: data.attributes.subteam.name
            }
          : { id: -1, name: 'None' }
      }

      commit(UPDATE_MEMBER, memberToUpdate)
      dispatch(
        'notification/pushNotification',
        {
          type: 'success',
          messages: [i18n.t('team.action.user-budget-update-success')]
        },
        { root: true }
      )
    } catch (error) {
      console.log(error)
      let errors = []
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [...errors[0].message]
            },
            { root: true }
          )
        }
      } else if (error.request) {
        errors.push(i18n.t('server.no-response'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      } else {
        errors.push(i18n.t('team.action.user-budget-update-error'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      }
    }
  },
  resetTeamState({ commit }) {
    commit(RESET_TEAM_STATE)
  }
}
